import { browserHistory } from "react-router";

const getLocationFromState = state => {
  if (!state || !state.routing) {
    return;
  }
  if (state.routing.locationBeforeTransitions) {
    return state.routing.locationBeforeTransitions;
  }

  return state.routing.location;
};

const getLocationFromBrowserHistory = () => {
  if (CLIENT) {
    return browserHistory.getCurrentLocation();
  }
};

export const getLocation = state => {
  const locationFromState = getLocationFromState(state);
  if (locationFromState) {
    return locationFromState;
  }

  return getLocationFromBrowserHistory();
};

export const getOriginalCurrentPriceRange = state => {
  const { currentpricerange = "" } = getLocation(state).query;

  if (currentpricerange === "") return {};

  return currentpricerange
    .split("-")
    .map(Number)
    .reduce((min, max) => ({ min, max }));
};

export const getPreviousLocation = state => state.routing.previousLocation;

export const hasUrlChanged = (state, newState) => {
  const { search } = getLocation({ routing: state }) || {};
  const { search: newSearch } = getLocation({ routing: newState }) || {};

  return search !== newSearch;
};
